import React from 'react';
import cn from 'classnames';
import { ControlLabel, FormControl, FormGroup, HelpBlock, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FieldGroup = ({
  id,
  label,
  bsSize,
  help,
  required,
  suggested,
  pre,
  post,
  labelClassName,
  helpClassName,
  validationState,
  children,
  ...props
}) => (
  <FormGroup controlId={id} bsSize={bsSize} validationState={validationState}>
    <div>
      <ControlLabel
        className={cn(labelClassName, { required, suggested })}
      >
        {label}
      </ControlLabel>
    </div>
    <div style={{ clear: 'both' }} />
    {(pre || post)
      ? (
        <InputGroup>
          {pre && <InputGroup.Addon>{pre}</InputGroup.Addon>}
          <FormControl {...props} >
            {children}
          </FormControl>
          {post && <InputGroup.Addon>{post}</InputGroup.Addon>}
        </InputGroup>)
      :
        <FormControl {...props} >
          {children}
        </FormControl>
    }
    {help && <HelpBlock className={cn(helpClassName)}>{help}</HelpBlock>}
  </FormGroup>
);

FieldGroup.propTypes = {
  id: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string]),
  bsSize: PropTypes.oneOf(['large', 'small']),
  help: PropTypes.string,
  required: PropTypes.bool,
  suggested: PropTypes.bool,
  pre: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string]),
  post: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string]),
  labelClassName: PropTypes.string,
  helpClassName: PropTypes.string,
  validationState: PropTypes.string,
  children: PropTypes.node,
};

export default FieldGroup;



// WEBPACK FOOTER //
// ./src/components/FieldGroup.js